export default "/images/anet-logo.png?00d94d3b28200c886e25b6d24d42477c";